import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../../colors';

export const useStyles = makeStyles({
  root: {
    padding: '16px 0',
  },
  top: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    paddingLeft: 24,
    paddingRight: 24,
    gap: 24,
  },
  input: {
    borderRadius: 4,
    border: '1px solid #D4DDE5',
    alignItems: 'center',
    flexGrow: 1,
    '& .MuiTextField-root': {
      '& .MuiInputBase-root': {
        height: 'auto',
        '& > fieldset': {
          border: 'none',
        },
        '& > input': {
          height: 48,
          color: colors.neutral500,
          textOverflow: 'ellipsis',
        },
      },
    },
  },
  inputDate: {
    borderRadius: 4,
    minWidth: 300,
    maxWidth: 400,
    alignItems: 'center',
    flex: 1,
    '& .MuiTextField-root': {
      '& .MuiInputBase-root': {
        height: 'auto',
        '& > fieldset': {
          border: 'none',
        },
        '& > input': {
          height: 48,
          color: colors.neutral500,
        },
      },
    },
  },
  inputDisabled: {
    opacity: 0.7,
  },
  bottom: {
    marginTop: 16,
    padding: 16,
    boxShadow: `inset 0px 1px 0px ${colors.dividerSecondary}`,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  tags: {
    display: 'flex',
    aligntems: 'center',
    flexWrap: 'wrap',
    gap: '8px 16px',
    flex: 1,
  },
  clearBtn: {
    marginTop: 10,
    marginLeft: 20,
    width: 'auto',
  },
});
